
// fallback size (in pt, same unit as every other numeric style value here) for the /sign overlay text input over
// receiptWorkOrderNumberField (see receiptHomeDepotFields.js). That marker View (printDocumentHeader.js) has no
// explicit width and its Text renders as "" during the isContractSign pass, so its measured @react-pdf/renderer
// box collapses to ~0 and can't be used to size the overlay - unlike the other homeDepotReceipt fields, whose
// marker Views all use styles.homeDepotFieldValue (width: "50%") and so have a reliable measured box.
export const RECEIPT_WORK_ORDER_FIELD_WIDTH = 48;
export const RECEIPT_WORK_ORDER_FIELD_HEIGHT = 12;

export default {
  sectionHomeDepotSide: {
    width: "30%",
    flex: "0 0 30%"
  },
  sectionHomeDepotCenter: {
    width: "40%",
    flex: "0 0 40%"
  },
  homeDepotFieldRow: {
    flexDirection: "row",
    width: "100%",
    marginBottom: 2,
  },
  homeDepotFieldLabel: {
    fontSize: 10,
    width: "50%",
    flex: "0 0 50%",
  },
  homeDepotFieldValue: {
    width: "50%",
    flex: "0 0 50%",
  },
}
